import '@/style.css';
import { createApp } from 'vue';
import App from './App.vue';
import router from './router/router.js';

// PrimeVue Core y Estilos
import PrimeVue from 'primevue/config';
import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';
import 'primeicons/primeicons.css';

import Tooltip from 'primevue/tooltip';
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';


const VestaAuraAzul = definePreset(Aura, {
    semantic: {
        primary: {
            50: '{sky.50}',
            100: '{sky.100}',
            200: '{sky.200}',
            300: '{sky.300}',
            400: '{sky.400}',
            500: '{sky.700}',//700
            600: '{sky.700}',
            700: '{sky.700}',
            800: '{sky.800}',
            900: '{sky.900}',
            950: '{sky.950}'
        },

    }
});

const esLocale = {
    startsWith: 'Comienza con',
    contains: 'Contiene',
    notContains: 'No contiene',
    endsWith: 'Termina con',
    equals: 'Igual a',
    notEquals: 'No igual a',
    // ... otros textos globales
    fileinput: {
        choose: 'Seleccionar',
        upload: 'Subir',
        cancel: 'Cancelar',
        dragdrop: 'Arrastra y suelta archivos aquí para subir.',
        // Mensajes de error y validación:
        maxFileSize: 'Tamaño máximo de archivo: {0}.', // {0} es un placeholder
        invalidFileType: 'Tipo de archivo no válido.',
        invalidFile: 'Archivo no válido.',
        fileLimit: 'Se ha excedido el límite de archivos, solo se permite {0}.',
        emptyMessage: 'Ningún archivo seleccionado',
    },

    // Si estás usando el modo 'basic', los textos también pueden estar en la raíz:
    upload: 'Subir',
    choose: 'Seleccionar',
    cancel: 'Cancelar',

    noFilter: 'Sin filtro',
    dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
    monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
    weekHeader: 'Sem',
    emptyMessage: 'No se encontraron resultados',

    // Textos del FileUpload
    empty: 'Arrastra y suelta archivos aquí para subir.', // Texto de arrastrar y soltar
    // ... otros mensajes de FileUpload como maxFileSize, invalidFileType, etc., si los necesitas
};


const app = createApp(App);
app.directive('tooltip', Tooltip);
app.use(router);
app.use(PrimeVue, {
    theme: {
        preset: VestaAuraAzul,
        locale: esLocale,
        ripple: true,
        options: {
            //darkModeSelector: '.mi-modo-oscuro'
            darkModeSelector: 'none'
        }
    },
});


app.use(ToastService);
app.use(ConfirmationService);
app.mount('#app');